import * as React from "react";
import Svg, { Path } from "react-native-svg";

function ArrowRightMedium(props) {
  const { fill } = props;
  return (
    <Svg
      width={18}
      height={15}
      viewBox="0 0 18 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <Path
        d="M1.082 8.728c.074.011.148.017.223.016h12.698l-.277.125c-.27.124-.517.294-.727.5l-3.561 3.46a1.268 1.268 0 00-.187 1.659 1.313 1.313 0 001.932.162l6.44-6.257c.502-.488.503-1.28 0-1.77L11.182.364A1.315 1.315 0 009.25.49a1.268 1.268 0 00.187 1.659l3.554 3.466c.19.184.406.338.644.457l.387.169H1.376C.718 6.217.14 6.664.016 7.292c-.113.682.364 1.325 1.066 1.436z"
        fill={fill || "#fff"}
      />
    </Svg>
  );
}

export default ArrowRightMedium;
